import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export class PvToolEegVerguetung extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_EEG_VERGUETUNG}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    customFormConfig = {{
                        wert: {decimals: 6},
                        wert_10: {decimals: 6},
                        wert_40: {decimals: 6},
                        wert_100: {decimals: 6},
                    }}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_EEG_VERGUETUNG)}
                />
            </div>
        );
    }
}
